/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Show_PastInputs */



/**
* | output |
* | --- |
* | "Show past leagues" |
*
* @param {League_Show_PastInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_show_past = /** @type {((inputs?: League_Show_PastInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Show_PastInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher les ligues passées")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar ligas pasadas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mostrar ligas encerradas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra campionati passati")
	return /** @type {LocalizedString} */ ("Show past leagues")
});